import { render, staticRenderFns } from "./AddOption.vue?vue&type=template&id=d20c54ec"
import script from "./AddOption.vue?vue&type=script&lang=js"
export * from "./AddOption.vue?vue&type=script&lang=js"
import style0 from "./AddOption.vue?vue&type=style&index=0&id=d20c54ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports